import React from "react";
import MainButton from "../MainButton";

function Footer() {
  return (
    <footer className="bg-white">
      <div className="container page-padding py-[10rem]">
        <div className="flex justify-between min620:flex-col min620:items-center min620:text-center min620:gap-[5rem] !text-left">
          {/* logo side */}
          <div className="flex flex-col w-1/3 gap-8">
            <h1 className="text-4xl"></h1>
            <p className="text-[15px] font-medium text-[#646464]">
            "Ready to transform your fitness journey? Join HIFI Fitness Gym today and experience personalized training like never before!"
            </p>
            {/* socials */}
            <div className="flex gap-7 text-[18px] text-[#646464] min540:justify-center">
                <a href="https://www.facebook.com/p/HI-FI-Fitness-100064087483090" target="_blank" rel="noopener noreferrer">
                  <i className="fa-brands fa-facebook-f p-[12px] bg-[#f4f4f4] rounded-full cursor-pointer hover:bg-[#1877F2] ease-in duration-200 hover:text-white"></i>
                </a>
               
                <a href="https://www.instagram.com/hifi_fitness_parrys/?hl=en" target="_blank" rel="noopener noreferrer">
                  <i className="fa-brands fa-instagram p-[12px] bg-[#f4f4f4] rounded-full cursor-pointer hover:bg-gradient-to-r from-[#f09433] via-[#e6683c] to-[#bc1888] ease-in duration-200 hover:text-white"></i>
                </a>
                <a href="https://wa.me/+918056171722?text=Hi, I would like to join HIFI fitness" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-whatsapp bg-[#efefef] p-[12px] rounded-full cursor-pointer hover:bg-[#25D366] ease-in duration-200 hover:text-white"></i>
                </a>

</div>

          </div>

          {/* middle div */}
          <div className="flex flex-col gap-8 relative">
            <p className="text-[22px] font-bold footer-main">Our Classes</p>
            <span className="top-[33px] absolute w-[7rem] h-[4px] bg-[#ff0366]"></span>
            <p className="text-[16px] hover:text-[#ff0366] cursor-pointer text-[#646464] font-medium hover:font-bold">Cardio</p>
            <p className="text-[16px] hover:text-[#ff0366] cursor-pointer text-[#646464] font-medium hover:font-bold">Aerobics</p>
            <p className="text-[16px] hover:text-[#ff0366] cursor-pointer text-[#646464] font-medium hover:font-bold">Cross-fit</p>
            <p className="text-[16px] hover:text-[#ff0366] cursor-pointer text-[#646464] font-medium hover:font-bold">Full-body Strength</p>
          </div>

          {/* right div */}
          <div className="flex flex-col gap-8 relative">
            <p className="text-[22px] font-bold footer-main">Working Hours</p>
            <span className="top-[33px] absolute w-[7rem] h-[4px] bg-[#ff0366]"></span>
            <p className="text-[16px] text-[#646464] font-bold">Monday - Saturday:</p>
            <p className="text-[16px] text-[#646464] font-medium">5:30am - 10:00 pm</p>
            <p className="text-[16px] text-[#646464] font-bold">Sunday:</p>
            <p className="text-[16px] text-[#646464] font-medium">
            7:00 am - 11:00 am</p>
            <p className="text-[16px] text-[#646464] font-medium"></p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;